const LocationIcon = ({ width = 22, height = 25, color = "#31493C" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.4091C21 17.7273 11 24 11 24C11 24 1 17.7273 1 10.4091C1 7.91364 2.05357 5.52041 3.92893 3.75586C5.8043 1.99131 8.34784 1 11 1C13.6522 1 16.1957 1.99131 18.0711 3.75586C19.9464 5.52041 21 7.91364 21 10.4091Z"
        stroke={color}
        strokeWidth="1.36822"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13C12.6569 13 14 11.8807 14 10.5C14 9.11929 12.6569 8 11 8C9.34315 8 8 9.11929 8 10.5C8 11.8807 9.34315 13 11 13Z"
        stroke={color}
        strokeWidth="1.36822"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LocationIcon;
